// Sound and vibration when a notification arrives while the app is open.
// Push notifications (app closed) use the device's own sound and vibration
// (see public/push-sw.js). Both settings are per device and on by default.

const SOUND_KEY = "somigo.notificationSound";
const VIBRATION_KEY = "somigo.notificationVibration";
const SOUND_URL = "/notification-sound.wav";
const VIBRATION_PATTERN = [200, 100, 200];

let audio = null;

const readSetting = (key) => {
  try {
    return localStorage.getItem(key) !== "off";
  } catch {
    return true;
  }
};

const writeSetting = (key, enabled) => {
  try {
    localStorage.setItem(key, enabled ? "on" : "off");
  } catch {
    // Storage can be blocked (e.g. private mode) - the setting just isn't kept
  }
};

export const isSoundEnabled = () => readSetting(SOUND_KEY);
export const setSoundEnabled = (enabled) => writeSetting(SOUND_KEY, enabled);
export const isVibrationEnabled = () => readSetting(VIBRATION_KEY);
export const setVibrationEnabled = (enabled) =>
  writeSetting(VIBRATION_KEY, enabled);

// Vibration only works in Android browsers (not on iPhone or desktop)
export const isVibrationSupported = () =>
  typeof navigator !== "undefined" && "vibrate" in navigator;

export const playNotificationSound = () => {
  if (!audio) audio = new Audio(SOUND_URL);
  audio.currentTime = 0;
  // Browsers block sound until the user has tapped or clicked in the app
  audio.play().catch(() => {});
};

// Only alert in a visible window: a hidden app gets the push notification
// instead, and only the tab that is being looked at should make a sound
export const alertNewNotification = () => {
  if (document.visibilityState !== "visible") return;
  if (isSoundEnabled()) playNotificationSound();
  if (isVibrationEnabled() && isVibrationSupported()) {
    navigator.vibrate(VIBRATION_PATTERN);
  }
};
